import { Breadcrumbs, Link, Typography } from "@mui/material";
import RefreshButton from "../../../../../common/components/refresh_button";
import PrincipaisDocGrid from "../../../../../common/components/principaisDocGrid";
import { useControlePatriPrincipalViewModel } from "../../viewModels/maquinas_equip_principal_view_model";

export const PrincipalControlePatrimonio = () => {

  const viewModel = useControlePatriPrincipalViewModel();
  return (
    <>
      <form>
        <div className="flex w-full gap-6 flex-col md:p-10 px-4 pt-8 mb-12">
          <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
            <Link underline="hover" color="inherit">
              Controle de Máquinas e Equipamentos
            </Link>
            <Typography className="text-primary-green">
              Principal
            </Typography>
          </Breadcrumbs>
          <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
            <div className="flex gap-2 items-center w-full">
              <h1 className="text-3xl font-medium text-black dark:text-white">Principal</h1>
              <RefreshButton onClick={viewModel.handleReload} />
            </div>
          </div>
          <PrincipaisDocGrid
            loading={viewModel.loading}
            rows={viewModel.docLista}
            totalItems={viewModel.pagination.totalItems}
            page={viewModel.pagination.page}
            rowsPerPage={viewModel.pagination.rowsPerPage}
            onPageChange={(p) => viewModel.handlePageChange(p)}
            onRowsPerPageChange={(p) => viewModel.handleRowsPerPageChange(p)}
            onActionExportar={(IdArquivoModulo, NomeArquivo) => viewModel.handleDownloadFile(IdArquivoModulo, NomeArquivo)}
          />
        </div>
      </form>
    </>
  )
};
